// @ts-ignore
import { ProFormText } from "@ant-design/pro-form";
import request from "../../../../../../utils/request";
import qs from "qs";
import { Card, Col, Empty, Row } from "antd";
import FileLinks from "../FileLinks";
const list = (data: any) => {
  const items = data.icon || []; //itemsMap[data.type];
  if (!items) return null;
  return items.map((item: any, index: number) => {
    return {
      span: "6",
      label: "",
      componentType: "custom",
      value: () => {
        return (
          <Card
            key={index}
            style={{ margin: "10px" }}
            bodyStyle={{
              border: "1px solid #026277",
              background: "#0a5566",
              color: "#fff",
              padding: "10px 24px",
            }}
          >
            <Row>
              <Col span={24} style={{ marginBottom: "10px" }}>
                {" "}
                {item.title}{" "}
              </Col>
            </Row>

            <Row>
              <Col span={24} style={{ marginBottom: "10px" }}>
                {item.down.map((file: any) => {
                  return FileLinks(JSON.stringify(file), "");
                })}
              </Col>
            </Row>
          </Card>
        );
      },
    };
  });
};
const typeOptions = [
  {
    label: "全部",
    value: 0,
  },
  {
    label: "标准地出让",
    value: 2,
  },
  {
    label: "划拨",
    value: 1,
  },
  {
    label: "挂牌",
    value: 3,
  },
  {
    label: "协议出让",
    value: 4,
  },
];
const constructionStatus = [
  {
    label: "全部",
    value: 0,
  },
  {
    label: "已供地",
    value: 1,
  },
  {
    label: "已开工",
    value: 2,
  },
  {
    label: "供而未建",
    value: 3,
  },
  {
    label: "已竣工",
    value: 4,
  },
];
export const getLandData = {
  key: "getLandData",
  config: {
    name: "批而未供土地",
    title: "批而未供",
    filter: {
      child: () => {
        // eslint-disable-next-line react/jsx-key
        return [
          <ProFormText placeholder="请输入地块名称" name="keys" key="keys" />,
          //   <ProFormText placeholder="请输入地块名称" name="keys1" key="keys1" />,
        ];
      },
      // beforeFilter(data) {
      //     data.years = moment(data.years).format('YYYY');
      //     return data;
      //   },
    },
    tabs(opts = {} as any) {
      const { type } = opts;
      const isTabs = [3, 5].includes(+type);
      if (!isTabs) {
        return [];
      }
      return [
        // {
        //   key: "1",
        //   label: `出让信息`,
        //   types: [
        //     typeOptions[1].value,
        //     typeOptions[3].value,
        //     typeOptions[2].value,
        //     typeOptions[4].value,
        //   ],
        //   panels(data = {} as any) {
        //     // const { type, data } = opts;
        //     return [
        //       {
        //         title: () => {
        //           return "";
        //         },
        //         items: [
        //           {
        //             span: "12",
        //             label: "地块名称",
        //             value: () => {
        //               return data.title || "-";
        //             },
        //           },
        //           {
        //             span: "12",
        //             label: "用地单位",
        //             value: () => {
        //               return data.company || "-";
        //             },
        //           },
        //           {
        //             span: "12",
        //             label: "界址范围",
        //             value: () => {
        //               return data.fanwei || "-";
        //             },
        //           },
        //           {
        //             span: "12",
        //             label: "出让编号",
        //             value: () => {
        //               return data.bianhao || "-";
        //             },
        //           },
        //           {
        //             span: "12",
        //             label: "出让面积",
        //             value: () => {
        //               return (
        //                 (data.mianji || "-") + "㎡ / " + (data.mu || "-") + "亩"
        //               );
        //             },
        //           },
        //           {
        //             span: "12",
        //             label: "用途",
        //             value: () => {
        //               return data.yongtu || "-";
        //             },
        //           },
        //           {
        //             span: "12",
        //             label: "供地方式",
        //             value: () => {
        //               return (
        //                 (
        //                   typeOptions.find((item) => item.value == data.type) ||
        //                   {}
        //                 ).label || "-"
        //               );
        //             },
        //           },
        //           {
        //             span: "12",
        //             label: "成交价（万元）",
        //             value: () => {
        //               return data.chengjiao || "-";
        //             },
        //           },
        //           {
        //             span: "12",
        //             label: "所属台账",
        //             value: () => {
        //               return data.years || "-";
        //             },
        //           },
        //           {
        //             span: "24",
        //             label: "备注",
        //             value: () => {
        //               return data.desc;
        //             },
        //           },
        //         ],
        //       },
        //     ];
        //   },
        // },
        {
          key: "2-2",
          label: `协议出让信息`,
          types: [typeOptions[4].value],
          panels(data: any) {
            return [
              {
                title: () => {
                  return "附件";
                },
                items: [
                  {
                    span: "24",
                    // label: '', // 有label 设置 label,
                    componentType: "file", // 针对地图,附件特殊标记
                    value: () => {
                      if (data.xieyi && data.xieyi.length) {
                        return data.xieyi.map((file: any) => {
                          return {
                            uid: file.id,
                            name: file.title,
                            url: file.urls,
                          };
                        });
                      }
                      return [];
                    },
                  },
                ],
              },
            ];
          },
        },
        {
          key: "2-2",
          label: `划拨信息`,
          types: [typeOptions[2].value],
          panels(data: any) {
            return [
              {
                title: () => {
                  return "";
                },
                items: [...list(data)],
              },
            ];
          },
        },
        {
          key: "2-1",
          label: `挂牌信息`,
          types: [typeOptions[3].value],
          panels(data: any) {
            return [
              {
                title: () => {
                  return "";
                },
                items: [...list(data)],
              },
            ];
          },
        },
        {
          key: "2",
          label: `标准地出让`,
          types: [typeOptions[1].value],
          panels(data: any) {
            return [
              {
                title: () => {
                  return "";
                },
                items: [...list(data)],
              },
            ];
          },
        },
        {
          key: "3",
          label: `公告信息`,
          types: [typeOptions[1].value, typeOptions[3].value],
          panels(data: any) {
            return [
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "12",
                    label: "公告时间",
                    value: () => {
                      return data.gg_time || "-";
                    },
                  },
                ],
              },
              {
                title: () => {
                  return "附件";
                },
                items: [
                  {
                    span: "24",
                    // label: '', // 有label 设置 label,
                    componentType: "file", // 针对地图,附件特殊标记
                    value: () => {
                      if (data.gonggao && data.gonggao.length) {
                        return data.gonggao.map((file: any) => {
                          return {
                            uid: file.id,
                            name: file.title,
                            url: file.urls,
                          };
                        });
                      }
                      return [];
                    },
                  },
                ],
              },
            ];
          },
        },
        {
          key: "4",
          label: `摘牌信息`,
          types: [typeOptions[1].value, typeOptions[3].value],
          panels(data: any) {
            return [
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "12",
                    label: "摘牌时间",
                    value: () => {
                      return data.atime || "-";
                    },
                  },
                ],
              },
              {
                title: () => {
                  return "附件";
                },
                items: [
                  {
                    span: "24",
                    // label: '', // 有label 设置 label,
                    componentType: "file", // 针对地图,附件特殊标记
                    value: () => {
                      if (data.zhaipai && data.zhaipai.length) {
                        return data.zhaipai.map((file: any) => {
                          return {
                            uid: file.id,
                            name: file.title,
                            url: file.urls,
                          };
                        });
                      }
                      return [];
                    },
                  },
                ],
              },
            ];
          },
        },
        {
          key: "5",
          label: `合同信息`,
          types: [
            typeOptions[1].value,
            typeOptions[3].value,
            typeOptions[2].value,
            typeOptions[4].value,
          ],
          panels(data: any) {
            return [
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "8",
                    label: "合同签订时间",
                    value: () => {
                      return data.ht_time || "-";
                    },
                  },
                  {
                    span: "8",
                    label: "开工日期",
                    value: () => {
                      return data.stime || "-";
                    },
                  },
                  {
                    span: "8",
                    label: "竣工日期",
                    value: () => {
                      return data.etime || "-";
                    },
                  },
                ],
              },
              {
                title: () => {
                  return "附件";
                },
                items: [
                  {
                    span: "24",
                    // label: '', // 有label 设置 label,
                    componentType: "file", // 针对地图,附件特殊标记
                    value: () => {
                      if (data.hetong && data.hetong.length) {
                        return data.hetong.map((file: any) => {
                          return {
                            uid: file.id,
                            name: file.title,
                            url: file.urls,
                          };
                        });
                      }
                      return [];
                    },
                  },
                ],
              },
            ];
          },
        },
        {
          key: "6",
          label: `消化批而未供土地`,
          types: [
            typeOptions[1].value,
            typeOptions[3].value,
            typeOptions[2].value,
            typeOptions[4].value,
          ],
          panels(data: any) {
            let maps: any[] = [];
            const piwen = (data.piwen || []).reduce((init: any, item: any) => {
              if (item) {
                if (Array.isArray(item.maps)) {
                  maps.push(...item.maps);
                } else {
                  maps.push(...JSON.parse(item.maps));
                }
              }
              init.push(
                ...[
                  {
                    span: "12",
                    label: "批准文号",
                    value: () => {
                      return item.piwen || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "所设面积",
                    value: () => {
                      return item.piwenmianji + "㎡" || "-";
                    },
                  },
                ]
              );
              return init;
            }, []);
            return [
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "24",
                    label: "面积",
                    value: () => {
                      return data.weigong || "-";
                    },
                  },
                  ...piwen,
                ],
              },
              // {
              //   title: () => {
              //     return "地理位置";
              //   },
              //   items: [
              //     {
              //       span: "24",
              //       componentType: "map",
              //       value: () => {
              //         return JSON.stringify(maps);
              //       },
              //     },
              //   ],
              // },
            ];
          },
        },
        {
          key: "7",
          label: `规划设计方案`,
          types: [typeOptions[1].value, typeOptions[3].value],
          panels(data: any) {
            return [
              {
                title: () => {
                  return "附件";
                },
                items: [
                  {
                    span: "24",
                    // label: '', // 有label 设置 label,
                    componentType: "file", // 针对地图,附件特殊标记
                    value: () => {
                      if (data.guihua && data.guihua.length) {
                        return data.guihua.map((file: any) => {
                          return {
                            uid: file.id,
                            name: file.title,
                            url: file.urls,
                          };
                        });
                      }
                      return [];
                    },
                  },
                ],
              },
            ];
          },
        },
      ].filter((item) => item.types.includes(type));
    },
    panels: (opts = {} as any) => {
      const { type, data } = opts;
      switch (type + "") {
        case "2": {
          // 控制性详细规划单元
          return [];
        }
        case "3":
        case "5": {
          // 土地出让总面积 （累计至今） sellland
          const typeOptions = [
            {
              label: "全部",
              value: 0,
            },
            {
              label: "标准地出让",
              value: 2,
            },
            {
              label: "划拨",
              value: 1,
            },
            {
              label: "挂牌",
              value: 3,
            },
            {
              label: "协议出让",
              value: 4,
            },
          ];
          return [
            {
              title: () => {
                return data.title;
              },
              panels: [
                {
                  title: () => {
                    return "出让信息";
                  },
                  items: [
                    {
                      span: "12",
                      label: "地块名称",
                      value: () => {
                        return data.title || "-";
                      },
                    },
                    {
                      span: "12",
                      label: "用地单位",
                      value: () => {
                        return data.company || "-";
                      },
                    },
                    {
                      span: "12",
                      label: "界址范围",
                      value: () => {
                        return data.fanwei || "-";
                      },
                    },
                    {
                      span: "12",
                      label: "出让编号",
                      value: () => {
                        return data.bianhao || "-";
                      },
                    },
                    {
                      span: "12",
                      label: "出让面积",
                      value: () => {
                        return (
                          (data.mianji || "-") +
                          "㎡" +
                          " / " +
                          (data.mu || "-") +
                          "亩"
                        );
                      },
                    },
                    {
                      span: "12",
                      label: "用途",
                      value: () => {
                        return data.yongtu || "-";
                      },
                    },
                    {
                      span: "12",
                      label: "供地方式",
                      value: () => {
                        return (
                          (
                            typeOptions.find(
                              (item) => item.value == data.type
                            ) || {}
                          ).label || "-"
                        );
                      },
                    },
                    {
                      span: "12",
                      label: "成交价（万元）",
                      value: () => {
                        return data.chengjiao || "-";
                      },
                    },
                    {
                      span: "12",
                      label: "所属台账",
                      value: () => {
                        return data.years || "-";
                      },
                    },
                    {
                      span: "24",
                      label: "备注",
                      value: () => {
                        return data.desc;
                      },
                    },
                  ],
                },
                // {
                //   title: () => {
                //     return "附件信息";
                //   },
                //   items: [
                //     {
                //       span: "24",
                //       // label: '', // 有label 设置 label,
                //       componentType: "file", // 针对地图,附件特殊标记
                //       value: () => {
                //         if (data.download && data.download.length) {
                //           return data.download.map((file: any) => {
                //             return {
                //               uid: file.id,
                //               name: file.title,
                //               url: file.urls,
                //             };
                //           });
                //         }
                //         return [];
                //       },
                //     },
                //   ],
                // },
                // {
                //   title: () => {
                //     return "地理位置";
                //   },
                //   items: [
                //     {
                //       span: "24",
                //       componentType: "map",
                //       value: () => {
                //         return data && data.maps;
                //       },
                //     },
                //   ],
                // },
              ],
            },
          ];
        }
        case "4": {
          // 本年度出让土地面积 addland
          return [
            {
              title: () => {
                return data.title;
              },
              panels: [
                {
                  title: () => {
                    return "基本信息";
                  },
                  items: [
                    {
                      span: "12",
                      label: "项目名称",
                      value: () => {
                        return data.title || "-";
                      },
                    },
                    {
                      span: "12",
                      label: "年度批次",
                      value: () => {
                        return (
                          data.years +
                          "年" +
                          (data.num || "-") +
                          "批" +
                          (data.cat_id || "-")
                        );
                      },
                    },
                    {
                      span: "12",
                      label: "总面积(亩)",
                      value: () => {
                        return data.total + "亩";
                      },
                    },
                    {
                      span: "12",
                      label: "农用地(亩)",
                      value: () => {
                        return data.n_land + "亩";
                      },
                    },
                    {
                      span: "12",
                      label: "其中耕地（亩）",
                      value: () => {
                        return (data.huishou || "-") + "亩";
                      },
                    },
                    {
                      span: "12",
                      label: "建设用地（亩）",
                      value: () => {
                        return data.j_land + "亩";
                      },
                    },
                    {
                      span: "12",
                      label: "未利用地(亩）",
                      value: () => {
                        return data.m_land + "亩";
                      },
                    },
                    {
                      span: "12",
                      label: "批复文号",
                      value: () => {
                        return data.piwen;
                      },
                    },
                    {
                      span: "12",
                      label: "省/市政府批准时间",
                      value: () => {
                        return data.etime;
                      },
                    },
                    {
                      span: "12",
                      label: "市政府征收公告文号",
                      value: () => {
                        return (
                          (data.years_1 || "-") +
                          "年 第" +
                          (data.num_1 || "-") +
                          "年"
                        );
                      },
                    },
                    {
                      span: "12",
                      label: "公告时间",
                      value: () => {
                        return data.gtime;
                      },
                    },
                    {
                      span: "12",
                      label: "涉及村",
                      value: () => {
                        return data.country;
                      },
                    },
                    {
                      span: "24",
                      label: "征迁项目",
                      value: () => {
                        return data.project;
                      },
                    },
                  ],
                },
                {
                  title: () => {
                    return "附件信息";
                  },
                  items: [
                    {
                      span: "24",
                      // label: '', // 有label 设置 label,
                      componentType: "file", // 针对地图,附件特殊标记
                      value: () => {
                        if (data.download && data.download.length) {
                          return data.download.map((file: any) => {
                            return {
                              uid: file.id,
                              name: file.title,
                              url: file.urls,
                            };
                          });
                        }
                        return [];
                      },
                    },
                  ],
                },
                // {
                //   title: () => {
                //     return "地理位置";
                //   },
                //   items: [
                //     {
                //       span: "24",
                //       componentType: "map",
                //       value: () => {
                //         return data && data.maps;
                //       },
                //     },
                //   ],
                // },
              ],
            },
          ];
        }

        case "6": {
          // 年度消化批而未 供土地面积 pierweigong
          return [
            {
              title: () => {
                return data.title;
              },
              panels: [
                {
                  title: () => {
                    return "基本信息";
                  },
                  items: [
                    {
                      span: "12",
                      label: "地块名称",
                      key: "title",
                      value: () => {
                        return data.title;
                      },
                    },
                    {
                      span: "12",
                      label: "面积（亩）",

                      value: () => {
                        return data.mianji + "亩";
                      },
                    },
                    {
                      span: "24",
                      label: "四至范围",
                      value: () => {
                        return data.fanwei;
                      },
                    },
                    {
                      span: "24",
                      label: "未供原因",
                      value: () => {
                        return data.yuanyin;
                      },
                    },
                  ],
                },
                {
                  title: () => {
                    return "附件信息";
                  },
                  items: [],
                },
              ],
            },
          ];
        }
        case "7": {
          // 租赁土地面积 leasedlland
          return [
            {
              title: () => {
                return data.title;
              },
              panels: [
                {
                  title: () => {
                    return "基本信息";
                  },
                  items: [
                    {
                      span: "12",
                      label: "地块名称",
                      value: () => {
                        return data.title || "-";
                      },
                    },
                    {
                      span: "12",
                      label: "位置",
                      value: () => {
                        return data.address || "-";
                      },
                    },
                    {
                      span: "12",
                      label: "承租单位",
                      value: () => {
                        return data.company || "-";
                      },
                    },
                    {
                      span: "12",
                      label: "租赁面积",
                      value: () => {
                        return (
                          (data.mianji || "-") +
                          "㎡ / " +
                          (data.mu || "-") +
                          "亩"
                        );
                      },
                    },
                    {
                      span: "12",
                      label: "起止时间",
                      value: () => {
                        return data.stime + "至" + data.etime;
                      },
                    },
                    {
                      span: "12",
                      label: "每年租金标准",
                      value: () => {
                        return (
                          (data.mj_price || "-") +
                          "元/㎡ / " +
                          (data.mu_price || "-") +
                          "元/亩"
                        );
                      },
                    },
                    {
                      span: "12",
                      label: "租金",
                      value: () => {
                        return data.price || "-";
                      },
                    },
                    {
                      span: "24",
                      label: "备注",
                      value: () => {
                        return data.desc;
                      },
                    },
                  ],
                },
                {
                  title: () => {
                    return "附件信息";
                  },
                  items: [
                    {
                      span: "24",
                      // label: '', // 有label 设置 label,
                      componentType: "file", // 针对地图,附件特殊标记
                      value: () => {
                        if (data.download && data.download.length) {
                          return data.download.map((file: any) => {
                            return {
                              uid: file.id,
                              name: file.title,
                              url: file.urls,
                            };
                          });
                        }
                        return [];
                      },
                    },
                  ],
                },
              ],
            },
          ];
        }
        case "8":
        case "9": {
          // 低效用地处置面积 (累计已完成) inefficientland
          return [
            {
              title: () => {
                return data.title;
              },
              panels: [
                {
                  title: () => {
                    return "基本信息";
                  },
                  items: [
                    {
                      span: "12",
                      label: "地块名称",
                      value: () => {
                        return data.title;
                      },
                    },
                    {
                      span: "12",
                      label: "出让面积（亩）",
                      value: () => {
                        return data.mianji + "亩";
                      },
                    },
                    {
                      span: "12",
                      label: "开工时间",
                      value: () => {
                        return data.stime;
                      },
                    },
                    {
                      span: "12",
                      label: "竣工时间",
                      value: () => {
                        return data.etime;
                      },
                    },
                    {
                      span: "12",
                      label: "拟收回面积（亩)",
                      value: () => {
                        return data.huishou + "亩";
                      },
                    },
                    {
                      span: "24",
                      label: "备注",
                      value: () => {
                        return data.desc || "-";
                      },
                    },
                  ],
                },
                {
                  title: () => {
                    return "附件信息";
                  },
                  items: [
                    {
                      span: "24",
                      // label: '', // 有label 设置 label,
                      componentType: "file", // 针对地图,附件特殊标记
                      value: () => {
                        if (data.download && data.download.length) {
                          return data.download.map((file: any) => {
                            return {
                              uid: file.id,
                              name: file.title,
                              url: file.urls,
                            };
                          });
                        }
                        return [];
                      },
                    },
                  ],
                },
              ],
            },
          ];
        }
        case "10": {
          //  本年度卫片图斑土 地处置面积 gpsland
          return [
            {
              title: () => {
                return data.title;
              },
              panels: [
                {
                  title: () => {
                    return "基本信息";
                  },
                  items: [
                    {
                      span: "12",
                      label: "地块名称",
                      value: () => {
                        return data.title;
                      },
                    },
                    {
                      span: "12",
                      label: "发现面积（亩）",
                      value: () => {
                        return data.mianji + "亩";
                      },
                    },
                    {
                      span: "12",
                      label: "涉及单位",
                      value: () => {
                        return data.danwei;
                      },
                    },
                    {
                      span: "12",
                      label: "土地权属",
                      value: () => {
                        return data.suoshu;
                      },
                    },
                    {
                      span: "12",
                      label: "处置面积（亩）",
                      value: () => {
                        return data.mianji1 + "亩";
                      },
                    },
                  ],
                },
              ],
            },
          ];
        }
      }
    },
    table: {
      pageSize: 10,
      async list(body: any) {
        const url = `/screen/Other/getLand`;
        // 需要针对Parms 进行处理
        const res = await request.get(url + "?" + qs.stringify(body));
        if (body.type == "2") {
          return res.data;
        }
        return res.data.data;
      },

      columns: (opts = {} as any) => {
        const { setSwitchDetail, type, tableParams } = opts;
        const base = {
          title: "序号",
          dataIndex: "",
          align: "center",
          render(_value: any, _record: any, index: number) {
            const { current = 1, pageSize = 10 } = tableParams.pagination;
            return index + 1 + (current - 1) * pageSize;
          },
        };
        switch (type + "") {
          case "2": {
            // 控制性详细规划单元
            return [
              base,
              {
                title: "单元名称",
                align: "center",
                dataIndex: "title",
                render(_value: any, _record: any, index: number) {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        // setSwitchDetail?.(_record);
                      }}
                    >
                      {_value}
                    </div>
                  );
                },
              },
              {
                title: "面积（公顷）",
                align: "center",
                dataIndex: "areas",
                render(_value: any, _record: any, index: number) {
                  return _value + "公顷";
                },
              },
              {
                title: "批复文件",
                align: "center",
                dataIndex: "file1_title",
                render(_value: any, _record: any, index: number) {
                  return (
                    <a href={_record.file1_urls} target="_black">
                      {_value}
                    </a>
                  );
                },
              },
              {
                title: "规划图",
                align: "center",
                dataIndex: "file2_title",
                render(_value: any, _record: any, index: number) {
                  return (
                    <a href={_record.file2_urls} target="_black">
                      {_value}
                    </a>
                  );
                },
              },
            ];
          }
          case "3": {
            // 土地出让总面积 （累计至今）
            return [
              base,
              {
                title: "地块名称",
                align: "center",
                dataIndex: "title",
                render(_value: any, _record: any, index: number) {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        const url = `/screen/Other/getLandDetails`;
                        // 需要针对Parms 进行处理
                        const res = await request.get(
                          url +
                            "?" +
                            qs.stringify({
                              id: _record.id,
                            })
                        );
                        setSwitchDetail?.(res.data.data);
                      }}
                    >
                      {_value}
                    </div>
                  );
                },
              },
              {
                title: "用地企业",
                align: "center",
                dataIndex: "company",
              },
              {
                title: "界址范围",
                align: "center",
                dataIndex: "fanwei",
              },
            ];
          }
          case "4": {
            // 本年度新增土地面积
            return [
              base,
              {
                title: "项目",
                align: "center",
                dataIndex: "title",
                render(_value: any, _record: any, index: number) {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSwitchDetail?.(_record);
                      }}
                    >
                      {_value}
                    </div>
                  );
                },
              },
              {
                title: "年度批次",
                align: "center",
                dataIndex: "years",
              },
              {
                title: "总面积（亩",
                align: "center",
                dataIndex: "n_land",
              },
            ];
          }
          case "5": {
            // 本年度出让土地面积
            return [
              base,
              {
                title: "地块名称",
                dataIndex: "title",
                align: "center",
                render(_value: any, _record: any, index: number) {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        // setSwitchDetail?.(_record);
                      }}
                    >
                      {_value}
                    </div>
                  );
                },
              },
              {
                title: "用地企业",
                dataIndex: "company",
                align: "center",
              },
              {
                title: "供地方式",
                dataIndex: "type",
                align: "center",
                render(value: any) {
                  const item = typeOptions.find(
                    (opt) => opt.value === value
                  ) as any;
                  return item.label;
                },
              },
              ,
              {
                title: "建设状态",
                dataIndex: "status",
                align: "center",
                render(value: number) {
                  if (value === 0) {
                    return "-";
                  }
                  const item = constructionStatus.find(
                    (opt) => opt.value === value
                  ) as any;
                  return item.label;
                },
              },
              {
                title: "界址范围",
                dataIndex: "fanwei",
                align: "center",
              },
            ];
          }
          case "6": {
            //   年度消化批而未 供土地面积
            return [
              base,
              {
                title: "地块名称",
                align: "center",
                dataIndex: "title",
                render(_value: any, _record: any, index: number) {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSwitchDetail?.(_record);
                      }}
                    >
                      {_value}
                    </div>
                  );
                },
              },
              {
                title: "面积（亩）",
                dataIndex: "mianji",
                hideInSearch: true,
              },
              {
                title: "四至范围",
                dataIndex: "fanwei",
                hideInSearch: true,
              },
              {
                title: "未供原因",
                dataIndex: "yuanyin",
                hideInSearch: true,
              },
            ];
          }
          case "7": {
            // 租赁土地面积
            return [
              base,
              {
                title: "地块名称位置",
                align: "center",
                dataIndex: "title",
                render(_value: any, _record: any, index: number) {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSwitchDetail?.(_record);
                      }}
                    >
                      {_value}
                    </div>
                  );
                },
              },
              {
                title: "承租企业",
                align: "center",
                dataIndex: "company",
              },
              {
                title: "租赁面积（㎡/亩）",
                align: "center",
                dataIndex: "mianji",
              },
              //   {
              //     title: "租赁时间年数",
              //     align: "center",
              //     dataIndex: "mianji",
              //   },
            ];
          }
          case "8":
          case "9": {
            // 低效用地处置面积 (累计已完成)
            return [
              base,
              {
                title: "地块名称",
                align: "center",
                dataIndex: "title",
                render(_value: any, _record: any, index: number) {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSwitchDetail?.(_record);
                      }}
                    >
                      {_value}
                    </div>
                  );
                },
              },
              {
                title: "出让面积(亩)",
                align: "center",
                dataIndex: "mianji",
              },
              {
                title: "拟收回面积（亩）",
                align: "center",
                dataIndex: "huishou",
              },
            ];
          }

          case "10": {
            // 本年度卫片图斑土 地处置面积
            return [
              base,
              {
                title: "地块名称",
                align: "center",
                dataIndex: "title",
                render(_value: any, _record: any, index: number) {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSwitchDetail?.(_record);
                      }}
                    >
                      {_value}
                    </div>
                  );
                },
              },
              {
                title: "年份",
                align: "center",
                dataIndex: "years",
              },
              {
                title: "发现面积（亩）",
                align: "center",
                dataIndex: "mianji",
              },
              {
                title: "处置面积（亩）",
                align: "center",
                dataIndex: "mianji1",
              },
              {
                title: "图斑号",
                align: "center",
                dataIndex: "bianhao",
              },
              {
                title: "处置面积（亩）",
                align: "center",
                dataIndex: "mianji1",
              },
              {
                title: "涉及单位",
                align: "center",
                dataIndex: "danwei",
              },
              {
                title: "土地权属",
                align: "center",
                dataIndex: "suoshu",
              },
            ];
          }
        }
      },
    },
  },
} as any;
